import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./styles/globals.css";
import "./styles/custom-theme.css"; // Import custom theme overrides

createRoot(document.getElementById("root")!).render(<App />);
